(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["midori-social-share"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.midori-social-share__btn--instagram').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var url = btn.getAttribute('data-copy-url');
      var title = btn.getAttribute('data-share-title') || document.title;
      var label = btn.querySelector('.midori-social-share__insta-label');
      var original = label ? label.textContent : 'Instagram';
      var isMobile = window.innerWidth < 768 || /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);

      function copyToClipboard() {
        function showCopied() {
          if (label) { label.textContent = 'Copied!'; }
          setTimeout(function() { if (label) { label.textContent = original; } }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showCopied).catch(fallbackCopy);
        } else {
          fallbackCopy();
        }
        function fallbackCopy() {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          showCopied();
        }
      }

      if (isMobile && navigator.share) {
        navigator.share({ title: title, url: url }).catch(function() {});
      } else {
        copyToClipboard();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
